// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__24Z3G","radioRow":"SimpleQuestionBuilderModal_radioRow__1vg9V"};